export const parsePxValueToNumber = (value: string) => parseInt(value.replace('px', ''), 10);
